// Field definitions for the Knowledge CMS pages.
// Profiles are grouped into sections (one card each). kind: input | textarea | switch | team
export const PROFILES = {
  company: {
    type: 'company_profile',
    i18nKey: 'COMPANY',
    sections: [
      {
        key: 'ABOUT',
        fields: [
          { name: 'name', kind: 'input' },
          { name: 'website', kind: 'input' },
          { name: 'description', kind: 'textarea' },
        ],
      },
      {
        key: 'CONTACT',
        fields: [
          { name: 'phone_numbers', kind: 'textarea' },
          { name: 'emails', kind: 'textarea' },
          { name: 'address', kind: 'textarea' },
        ],
      },
      {
        key: 'MORE',
        fields: [
          { name: 'business_hours', kind: 'textarea' },
          { name: 'other_info', kind: 'textarea' },
        ],
      },
    ],
  },
  ai: {
    type: 'ai_profile',
    i18nKey: 'AI',
    sections: [
      { key: 'STATUS', fields: [{ name: 'ai_enabled', kind: 'switch' }] },
      {
        key: 'VOICE',
        fields: [
          { name: 'language', kind: 'input' },
          { name: 'dialect', kind: 'input' },
          { name: 'tone', kind: 'input' },
          { name: 'communication_style', kind: 'textarea' },
        ],
      },
      {
        key: 'BEHAVIOR',
        fields: [{ name: 'behavior_instructions', kind: 'textarea' }],
      },
      {
        key: 'HANDOVER',
        fields: [
          { name: 'handover_instructions', kind: 'textarea' },
          { name: 'handover_team_id', kind: 'team' },
        ],
      },
    ],
  },
};

export const ITEMS = {
  products: {
    key: 'product',
    i18nKey: 'PRODUCTS',
    titleField: 'name',
    subtitleField: 'description',
    fields: [
      { name: 'name', kind: 'input', required: true },
      { name: 'price', kind: 'input' },
      { name: 'description', kind: 'textarea' },
      { name: 'details', kind: 'textarea' },
    ],
  },
  services: {
    key: 'service',
    i18nKey: 'SERVICES',
    titleField: 'name',
    subtitleField: 'description',
    fields: [
      { name: 'name', kind: 'input', required: true },
      { name: 'description', kind: 'textarea' },
      { name: 'details', kind: 'textarea' },
      { name: 'conditions', kind: 'textarea' },
    ],
  },
  faqs: {
    key: 'faq',
    i18nKey: 'FAQS',
    titleField: 'question',
    subtitleField: 'answer',
    fields: [
      { name: 'question', kind: 'textarea', required: true },
      { name: 'answer', kind: 'textarea', required: true },
    ],
  },
  policies: {
    key: 'policy',
    i18nKey: 'POLICIES',
    titleField: 'title',
    subtitleField: 'content',
    fields: [
      { name: 'title', kind: 'input', required: true },
      { name: 'content', kind: 'textarea', required: true },
    ],
  },
};

export const TEXT_LIMIT = 10000;
